import React from 'react'
import { Checkbox, Space } from 'antd'
import {
  FilterCard,
  ClearAllButton,
  FilterHeader,
  StyledDivider,
} from '../../Style'
import { FilterSection, FilterTitle } from '../../../../components/FilterStyles'

const CompletedFilter = ({
  timeFilter = [],
  assessmentTypeFilter = [],
  onTimeFilterChange,
  onAssessmentTypeChange,
  onClearAll,
}) => {
  const timeFilterOptions = [
    { label: 'This week', value: 'thisWeek' },
    { label: 'This month', value: 'thisMonth' },
    { label: 'Last months', value: 'lastMonth' },
  ]

  const assessmentTypeOptions = [
    { label: 'Communication Assessment', value: 'communication' },
    { label: 'Behavioural Assessment', value: 'behavior' },
    { label: 'Aptitude Assessment', value: 'aptitude' },
    // { label: 'Cognitive Aptitude', value: 'cognitive' },
    // { label: 'Technical Assmt. - MCQ', value: 'tech_mcq' },
    // { label: 'Technical Assmt. - Coding', value: 'tech_coding' },
  ]

  return (
    <FilterCard>
      <FilterHeader>
        <FilterTitle>Filter</FilterTitle>
        <ClearAllButton onClick={onClearAll}>Clear all</ClearAllButton>
      </FilterHeader>
      <StyledDivider />

      <FilterSection>
        <FilterTitle>Time Period</FilterTitle>
        <Checkbox.Group value={timeFilter} onChange={onTimeFilterChange}>
          <Space direction="vertical">
            {timeFilterOptions.map(option => (
              <Checkbox key={option.value} value={option.value}>
                {option.label}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </FilterSection>

      <FilterSection>
        <FilterTitle>Assessment Type</FilterTitle>
        <Checkbox.Group
          value={assessmentTypeFilter}
          onChange={onAssessmentTypeChange}
        >
          <Space direction="vertical">
            {assessmentTypeOptions.map(option => (
              <Checkbox key={option.value} value={option.value}>
                {option.label}
              </Checkbox>
            ))}
          </Space>
        </Checkbox.Group>
      </FilterSection>
    </FilterCard>
  )
}

export default CompletedFilter
